import { gql } from "@apollo/client";

export const GET_CLIENT_META_INFO_QUERY = gql`
  query GetClientMetaInfo($clientId: Int!) {
    clientMetaInfo(clientId: $clientId) {
      id
      companyName
      website
      existingVendor
      mutualConnection
      upcomingEvent
      newCampaignRebrand
      hiringExpansion
      csrSustainability
      recentNews
      keyTimingInsight
      whatMattersMost
      challengesFacing
      primaryContactName
      primaryContactEmail
      primaryContactPhone
      fax
      howWeHelp
      proofPointExample
      subjectLineIdea
      personalizedOpener
      visualAttachment
      cta
      followUpSequence
      nextStepStatus
      createdAt
      updatedAt
    }
  }
`;
